var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        {
          attrs: { title: "Información de contacto de la Unidad Contratante" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    error: errors[0],
                                    label: "Nombre:"
                                  },
                                  model: {
                                    value: _vm.model.contactName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "contactName", $$v)
                                    },
                                    expression: "model.contactName"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2514682989
                      )
                    })
                  : _vm.isReadOnly
                  ? _c("div", { staticClass: "d-flex flex-column my-2" }, [
                      _c("span", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Nombre:")
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("empty")(_vm.model.contactName)))
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            !_vm.isReadOnly
              ? _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("custom-input", {
                      attrs: { label: "Inicial:" },
                      model: {
                        value: _vm.model.contactMiddleInitial,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "contactMiddleInitial", $$v)
                        },
                        expression: "model.contactMiddleInitial"
                      }
                    })
                  ],
                  1
                )
              : _vm.isReadOnly
              ? _c("div", { staticClass: "col-1" }, [
                  _c("div", { staticClass: "d-flex flex-column my-2" }, [
                    _c("span", { staticClass: "color-gray-6 font-14" }, [
                      _vm._v("Inicial:")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("empty")(_vm.model.contactMiddleInitial))
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    error: errors[0],
                                    label: "Apellido Paterno:"
                                  },
                                  model: {
                                    value: _vm.model.contactPaternalLastName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "contactPaternalLastName",
                                        $$v
                                      )
                                    },
                                    expression: "model.contactPaternalLastName"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2517816618
                      )
                    })
                  : _vm.isReadOnly
                  ? _c("div", { staticClass: "d-flex flex-column my-2" }, [
                      _c("span", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Apellido Paterno:")
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("empty")(_vm.model.contactPaternalLastName)
                          )
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            !_vm.isReadOnly
              ? _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("custom-input", {
                      attrs: { label: "Apellido Materno:" },
                      model: {
                        value: _vm.model.contactMaternalLastName,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "contactMaternalLastName", $$v)
                        },
                        expression: "model.contactMaternalLastName"
                      }
                    })
                  ],
                  1
                )
              : _vm.isReadOnly
              ? _c("div", { staticClass: "col-4" }, [
                  _c("div", { staticClass: "d-flex flex-column my-2" }, [
                    _c("span", { staticClass: "color-gray-6 font-14" }, [
                      _vm._v("Apellido Materno:")
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("empty")(_vm.model.contactMaternalLastName)
                        )
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo es requerido.",
                                    disabled:
                                      _vm.model.contactOffice &&
                                      _vm.offices.length == 1,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Oficina:",
                                    options: _vm.offices
                                  },
                                  model: {
                                    value: _vm.model.contactOffice,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "contactOffice", $$v)
                                    },
                                    expression: "model.contactOffice"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3707308942
                      )
                    })
                  : _vm.isReadOnly
                  ? _c("div", { staticClass: "d-flex flex-column my-2" }, [
                      _c("span", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Oficina:")
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("empty")(_vm.model.contactOffice.name))
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: {
                        "custom-messages": {
                          required: "El campo es requerido.",
                          length: "El teléfono es invalido"
                        },
                        rules: "required|length:13"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    error: errors[0],
                                    label: "Teléfono:",
                                    "mask-type": "Phone",
                                    masked: ""
                                  },
                                  model: {
                                    value: _vm.model.contactPhoneNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "contactPhoneNumber",
                                        $$v
                                      )
                                    },
                                    expression: "model.contactPhoneNumber"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3173570011
                      )
                    })
                  : _vm.isReadOnly
                  ? _c("div", { staticClass: "d-flex flex-column my-2" }, [
                      _c("span", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Teléfono:")
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("empty")(_vm.model.contactPhoneNumber))
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-1" },
              [
                !_vm.isReadOnly
                  ? _c("custom-input", {
                      attrs: {
                        label: "Ext:",
                        "mask-type": "PhoneExt",
                        masked: ""
                      },
                      model: {
                        value: _vm.model.contactPhoneNumberExt,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "contactPhoneNumberExt", $$v)
                        },
                        expression: "model.contactPhoneNumberExt"
                      }
                    })
                  : _vm.isReadOnly
                  ? _c("div", { staticClass: "d-flex flex-column my-2" }, [
                      _c("span", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Extensión:")
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("empty")(_vm.model.contactPhoneNumberExt)
                          )
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      attrs: {
                        "custom-messages": {
                          required: "El campo es requerido.",
                          email: "El correo electrónico no es válido."
                        },
                        rules: "required|email"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    error: errors[0],
                                    label: "Correo Electrónico:"
                                  },
                                  model: {
                                    value: _vm.model.contactEmail,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "contactEmail", $$v)
                                    },
                                    expression: "model.contactEmail"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2779432907
                      )
                    })
                  : _vm.isReadOnly
                  ? _c("div", { staticClass: "d-flex flex-column my-2" }, [
                      _c("span", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Correo Electrónico:")
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("empty")(_vm.model.contactEmail)))
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }